/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    //"aws_cognito_identity_pool_id": "us-west-2:ef151d76-821b-459e-8037-bdfba3cb8d6e",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_QGTPfwqSA",
    "aws_user_pools_web_client_id": "7bqthv0qmok27nu05uc30mg9h4",
    "oauth": {
        "domain": "xtranslate.auth.us-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://www.xtranslate.ai/", //"http://localhost:3000/", //"https://www.xtranslate.ai/", // "chrome-extension://ahogmlahnmglmmhgdakigaijmjdnjmpo.chromiumapp.org/",  
        "redirectSignOut": "https://www.xtranslate.ai/", //"http://localhost:3000/", //"https://www.xtranslate.ai/", //"chrome-extension://ahogmlahnmglmmhgdakigaijmjdnjmpo.chromiumapp.org/", 
        "responseType": "code"
    },
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
      // Auth: {
    //     cookieStorage: {
    //         // - Cookie domain (only required if cookieStorage is provided)
    //         domain: '.google.com', // 'https://developer.chrome.com/', //'.yourdomain.com',
    //         // // (optional) - Cookie path
    //         path: '/',
    //         // (optional) - Cookie expiration in days
    //         expires: 365,
    //         // (optional) - See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
    //         sameSite: 'none', //'strict' | 'lax',
    //         // (optional) - Cookie secure flag
    //         // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
    //         secure: true
    //       },
    // }
};


export default awsmobile;
